import preparedReducer from './reducer';
import {
  requestCompany,
  enableVisitorLog,
  disableVisitorLog,
  enableSSO,
  disableSSO,
  updateSSOConfiguration,
  requestSSOConfiguration,
  enableBranches,
  disableBranches,
  updateMaxShiftHours,
  switchGpsRequired,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'companies';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestCompany,
  enableVisitorLog,
  disableVisitorLog,
  enableSSO,
  disableSSO,
  updateSSOConfiguration,
  requestSSOConfiguration,
  enableBranches,
  disableBranches,
  updateMaxShiftHours,
  switchGpsRequired,
};
